import { CallSession } from "@/common/models/callSession";
import { Position } from "@/common/theme/styleUtils";
import { CallTargetType, TransferType } from "@/common/types";
import { ContactListItem } from "@/repository/models";

export interface ContactsPanelProps {
	shadowTo: Position;
}

export interface EndMediaProps {
	contact: ContactListItem;
	onAddToFavoriteClick?: (contact: ContactListItem) => void;
	removeFromFavoriteClick?: (contact: ContactListItem) => void;
	onCallClick: (name: keyof ContactListItem, contact: ContactListItem) => void;
	onEditClick: (contact: ContactListItem) => void;
	onRemoveClick: (contact: ContactListItem) => void;
}

export interface CallMenuItemsProps {
	contact: ContactListItem;
	isOutboundPossible?: boolean;
	isOutboundAllowed?: boolean;
	hasAnyOutboundRightEndpoints?: boolean;
	onCallClick: (type: CallTargetType, contact: ContactListItem) => void;
	onTransferClick: (type: TransferType, transferTarget: string) => void;
	onAgendaClick: (contact: ContactListItem) => void;
	callSession: CallSession | null;
	isCallMenuOpened: boolean;
	setIsCallMenuOpened: (open: boolean) => void;
}

export interface ExtendedMenuItemsProps {
	contact: ContactListItem;
	showAddToFavorites: boolean;
	hideFavoriteOption: boolean;
	favoriteContactsIds: string[];
	notesPopover: JSX.Element;
	onFavoriteClick: (contact: ContactListItem) => void;
	onEditClick: (contact: ContactListItem) => void;
	onAgendaClick: (contact: ContactListItem) => void;
	onRemoveClick: (contact: ContactListItem) => void;
	isContactEditingAllowed: boolean;
}

export enum ContactGroupType {
	Favorites = "Favorites",
	All = "All",
	MyQueues = "MyQueues",
}

export interface ContactQueue {
	value: boolean;
	id: string;
	name: string;
}

export interface OperatorTemplatesProps {
	contact: ContactListItem;
	callSession: CallSession | null;
}
